// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const riolu: PokeData = {
  "id": 447,
  "name": "riolu",
  "height": 7,
  "weight": 202,
  "base_experience": 57,
  "types": [
    PokeType.FIGHTING
  ],
  "api_moves": [
    "swords-dance",
    "bite",
    "counter",
    "quick-attack",
    "screech",
    "reversal",
    "foresight",
    "endure",
    "metal-claw",
    "crunch",
    "rock-smash",
    "helping-hand",
    "iron-defense",
    "bulk-up",
    "feint",
    "close-combat",
    "copycat",
    "force-palm",
    "aura-sphere",
    "vacuum-wave",
    "nasty-plot",
    "bullet-punch",
    "quick-guard",
    "final-gambit",
    "work-up"
  ],
  "moves": [
    "bite",
    "quick-attack",
    "metal-claw",
    "crunch",
    "rock-smash",
    "bulk-up",
    "close-combat",
    "vacuum-wave",
    "rolling-kick",
    "superpower",
    "drain-punch",
    "double-kick",
    "coaching"
  ],
  "evolution_chain": {
    "id": 232,
    "item": null,
    "species": [
      {
        "name": "riolu",
        "order": 467,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lucario",
        "order": 468,
        "types": [
          PokeType.FIGHTING,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 447,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "day",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 40,
    "speed": 60,
    "ability_power": 70
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
